import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.73297 13.2574C10.7507 13.2574 13.1971 10.811 13.1971 7.79321C13.1971 4.77543 10.7507 2.32904 7.73297 2.32904C4.71519 2.32904 2.2688 4.77543 2.2688 7.79321C2.2688 10.811 4.71519 13.2574 7.73297 13.2574Z",
		stroke: "#707070",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.5632 14.6234L11.592 11.6523",
		stroke: "#707070",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSearch;
